import { authApi } from '@/store/auth/api/authApi.ts'
import { combineReducers } from '@reduxjs/toolkit'

import auth from './auth/slice/authSlice'
import core from './core/slice/coreSlice'

const coreReducer = combineReducers({
	auth,
	core,
	[authApi.reducerPath]: authApi.reducer,
})

type IRootState = ReturnType<typeof coreReducer>

export type DefaultRootState = IRootState

export { coreReducer }
